<template>
  <div>
    <div class="data-table report">
      <div class="report-done-switch influencer" @click="clicked = -1">
        <div class="report-influencer-breadcrumb">
          <span class="report-influencer-breadcrumb-num">{{ count }}</span
          >件
        </div>
        <div style="display:flex; flex-flow:row wrap; margin-left:20px; row-gap:10px">
          <el-select clearable v-model="filter.column" placeholder="カラム" style="width:100px; margin-right:10px" size="small">
            <el-option v-for="column in data.columns" :label="column.value" :value="column.value" :key="column.value"> </el-option>
          </el-select>
          <el-select clearable v-model="filter.type" placeholder="演算子" style="width:80px; margin-right:10px" size="small">
            <el-option label="=" value="="> </el-option>
            <el-option label="!=" value="!="> </el-option>
            <el-option label=">" value=">"> </el-option>
            <el-option label=">=" value=">="> </el-option>
            <el-option label="<" value="<"> </el-option>
            <el-option label="<=" value="<="> </el-option>
            <el-option label="like" value="like"> </el-option>
            <el-option label="rlike" value="rlike"> </el-option>
            <el-option label="IS NULL" value="IS NULL"> </el-option>
            <el-option label="IS NOT NULL" value="IS NOT NULL"> </el-option>
          </el-select>
          <el-input @change="search()" clearable v-model="filter.value" size="small" style="margin-right:10px; width:200px"></el-input>
          <el-button type="primary" size="small" @click="search()">
            <div class="flex-row">
              検索
              <div class="loader--mini" v-show="loading"></div>
            </div>
          </el-button>
          <el-button type="info" size="small" @click="reset()">リセット</el-button>
          <el-button
              v-if="type !== 'bright_data_gips'"
              type="info"
              size="small"
              @click="exportList()"
          >
            エクスポート
          </el-button>
          <!-- 条件付きレンダリング：Bright Data GIP の場合のみリフレッシュボタンを表示 -->
          <el-button
              v-if="type === 'bright_data_gips'"
              type="info"
              size="small"
              @click="refreshList()"
          >
            リフレッシュ
            <div class="loader--mini" v-show="loading"></div>
          </el-button>
        </div>
        <div class="flex-space"></div>
        <div>
          <el-select @change="change()" v-model="limit" placeholder="Select" style="width:70px" size="small">
            <el-option label="50" value="50"> </el-option>
            <el-option label="100" value="100"> </el-option>
            <el-option label="250" value="250"> </el-option>
          </el-select>
        </div>
        <div>
          <el-pagination @current-change="change()" :current-page.sync="currentPage" background layout="prev, pager, next" :total="count" :page-size="limit"></el-pagination>
        </div>
      </div>

      <div v-show="['deplicate_allow_domains', 'oem_list'].includes(type)" class="wrap-title" style="width:100%; margin-bottom:5px;">
        <div class="flex-space"></div>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="registChange(data)">新規登録</el-button>
      </div>
      <div class="data-table-admin-wrap" id="data-table">
        <table class="data-table-admin">
          <thead>
            <tr>
              <th v-for="(column, column_index) in data.columns" :key="column.id" class="data-table-admin-th" :class="column_index == 1 || column.sticky ? 'data-table-admin-th-title' : ''">
                <div class="pointer" style="display:flex; flex-flow:row" @click="sort(column.value)">
                  <div class="flex-column">
                    <div>{{ column.ja }}</div>
                    <div style="color:#aaa">{{ column.value }}</div>
                  </div>
                  <font-awesome-icon v-if="sort_key == column.value" :icon="['fas', sort_order == false ? 'arrow-up' : 'arrow-down']" style="margin-left:3px;" />
                </div>
              </th>
              <th class="data-table-admin-th" v-show="['deplicate_allow_domains', 'oem_list'].includes(type)" >
                <div class="pointer" style="display:flex; flex-flow:row; width:100%; justify-content:center">
                  <div class="flex-column">
                    <div>削除</div>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(list, list_index) in data.list"
              :key="list.id"
              class="data-table-admin-tr"
              @dblclick="clicked == list_index ? (clicked = -1) : (clicked = list_index)"
              :class="clicked == list_index ? 'clicked' : ''"
            >
              <td
                v-for="(item, item_index) in list"
                :key="item.id"
                class="data-table-admin-td"
                :class="item_index == 1 || item.sticky ? 'data-table-admin-td-title' : ''"
                :style="item_index == edit_item ? 'min-width:160px' : ''"
                @click="item.editable ? editOn(list_index, item_index, item.value) : ''"
              >
                <div class="data-table-admin-td-div">
                  <div v-if="item.session" class="status-button transparent" :class="item.time >= timestamp ? 'success' : ''" style="width:14px; margin-right: 10px;"></div>
                  <div v-if="item.sending" class="status-button success" style="width:14px; margin-right: 10px;"></div>
                  <el-input
                    @change="confirm(list_index, item_index, item.edit_index, edit, item.confirm, item.column)"
                    @blur="editOff()"
                    size="small"
                    v-model="edit"
                    v-if="list_index == edit_list && item_index == edit_item && !item.editImage"
                    :id="list_index + '-' + item_index"
                  ></el-input>

                  <div v-else-if="list_index == edit_list && item_index == edit_item && item.editImage === true">
                    <input 
                      :id="list_index + '-' + item_index"
                      type="file" 
                      @change="onFileChange($event, list_index, item_index)" 

                      accept="image/*"
                      style="margin-top:10px; margin-bottom:10px;"
                    />
                    <div v-if="item.value" class="image-preview">
                      <img :src="item.value" alt="Image preview" style="margin-bottom:10px;"/>
                      <div class="button-container" style="margin-bottom:10px; display: flex; justify-content: flex-end;">
                        <el-button 
                          type="primary"
                          @click="confirm(list_index, item_index, item.edit_index, item.value, item.confirm, item.column)"
                          size="small"
                          style="margin-bottom:5px; width:14px;"
                        >
                          <div class="flex-row">
                            変更
                            <div class="loader--mini" v-show="loading"></div>
                          </div>
                        </el-button>
                      </div>
                    </div>
                  </div>

                  <span v-else>
                    <el-switch
                      v-if="item.switch"
                      v-model="item.value"
                      active-value="1"
                      inactive-value="0"
                      @change="confirm(list_index, item_index, item.edit_index, item.value, item.confirm, item.column)"
                      :disabled="item.nonretroactive && item.value == 1"
                    ></el-switch>
                    <span v-else-if="item.value == null" style="color:#ccc; font-style: italic;">NULL</span>
                    <img v-else-if="item.picture" :src="item.value ? item.value : ''" style="width:25px; height:25px;" alt="" />
                    <a v-else-if="item.link" :href="item.value" target="_blank" class="router-link">{{ item.value }}</a>
                    <span v-else @click="item.detail ? openDrawer(item.value) : ''" :class="item.detail ? 'router-link' : clicked == list_index ? 'data-table-admin-span-clicked' : ''">
                      {{ item.value }}
                    </span>
                    <font-awesome-icon :icon="['fas', 'edit']" style="margin-left: 10px; color:#0095f6" v-if="item.editable" />
                    <font-awesome-icon :icon="['fas', 'external-link-alt']" class="pointer" style="margin-left: 10px; color:#0095f6" v-if="item.e" @click="eLogin(item.value)" />
                    <font-awesome-icon :icon="['fas', 'file-alt']" style="margin-left: 5px;" class="pointer" v-if="item.get && item.value" @click="getInfo(list_index, item_index)" />
                  </span>
                </div>
                <el-button type="info" size="small" v-if="item_index === list.length-1 && ['influencer', 'youtuber_list', 'tiktoker_list'].includes(type)" :disabled="processing" @click="updateData(list_index)">データ更新</el-button>
                <el-button type="info" size="small" v-if="item_index === list.length-1 && ['member'].includes(type)" :disabled="processing" @click="changeSuperAdmin(list_index)">変更</el-button>
              </td>

              <td v-show="['deplicate_allow_domains', 'oem_list'].includes(type)" class="data-table-admin-td">
                <div class="check-parts pointer" style="width: 100%; justify-content:center" @click="deleteChange(list_index)">
                  <i class="el-icon-delete" style="font-size: 14px"></i></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="i-detail-modal" :class="drawer ? 'open' : ''" id="i-detail-scroll">
      <router-view ref="iDetail" v-show="drawer"></router-view>
    </div>
    <div class="overlay" :class="drawer ? 'open' : ''" @click="closeDrawer"></div>
    <adminRegist :admin_regist_modal.sync="admin_regist_modal" :registColumns="registColumns" :tableName="tableName" @load="load()"/>
  </div>
</template>

<script>
import list_column from "@/components/list/list_column.vue";
import adminRegist from "./adminRegist";
import { handleApiResponse } from "@/components/common/responseHelper";

const root = process.env.VUE_APP_API;
const loadAPI = root + "/api/admin/admin_load";
const exportAPI = root + "/api/admin/admin_export";
const editAPI = root + "/api/admin/admin_edit";
const loadSuperAdminAPI = root + "/api/admin/load_super_admin";
const changeSuperAdminAPI = root + "/api/admin/change_super_admin";
const getInfoAPI = root + "/api/scraping/target_list_eight";
const updateData = root + "/api/scraping/update_influencer";
const deleteAPI = root + "/api/admin/admin_delete";
const adminGipUpdaterAPI = root + "/api/admin/admin_gip_updater";

export default {
  name: "adminList",
  props: {
    type: {
      type: String,
      required: true
    },
    notification: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    adminRegist,
  },
  data() {
    return {
      data: [],
      count: 0,
      limit: 50,
      sort_order: true,
      sort_key: "",
      currentPage: 1,
      filter: {
        column: "",
        type: "rlike",
        value: "",
      },
      loading: false,
      clicked: -1,
      edit: "",
      edit_list: -1,
      edit_item: -1,
      drawer: false,
      timestamp: 9999999999,
      processing: false,
      admin_regist_modal: false,
      registColumns: [],
      tableName: "",
      currentTab: "",
    };
  },
  computed: {
    list_column() {
      return list_column
    },
    token() {
      return this.$store.state.token;
    },
    filterOn() {
      if (this.filter.column && this.filter.type) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.timeNow();
    this.load();
    setInterval(this.timeNow, 1000);
  },
  methods: {
    load(not_scroll) {
      this.loading = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("type", this.type);
      params.append("sort_key", this.sort_key);
      params.append("sort_order", this.sort_order);
      params.append("currentPage", this.currentPage);
      params.append("limit", this.limit);
      params.append("filter", this.filterOn ? JSON.stringify(this.filter) : "");
      this.axios
        .post(loadAPI, params)
        .then((response) => {
          this.data = response.data.data;
          this.count = response.data.data.count;
          this.sort_key = response.data.data.sort_key;
          this.$emit("update:notification", response.data.notification);
          this.loading = false;
          if (!not_scroll) {
            this.scrollTop();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    exportList() {
      this.$confirm(this.type + "をエクスポートしますか？（リストはxlsx形式でエクスポートされます）", "リストエクスポート", {
        distinguishCancelAndClose: true,
        type: "info",
        confirmButtonText: "ダウンロード",
        cancelButtonText: "キャンセル",
      }).then(() => {
        location.href =
          exportAPI + "?token=" + this.token + "&type=" + this.type + "&sort_key=" + this.sort_key + "&sort_order=" + this.sort_order + "&filter=" + (this.filterOn ? JSON.stringify(this.filter) : "");
      });
    },
    sort(key) {
      if (key == this.sort_key) {
        this.sort_order = !this.sort_order;
      } else {
        this.sort_order = true;
      }
      this.count = 0;
      this.sort_key = key;
      this.load();
    },
    change() {
      this.load();
    },
    search() {
      this.load();
    },
    reset() {
      this.filter.column = "";
      this.filter.type = "rlike";
      this.filter.value = "";
      this.load();
    },
    editOn(list_index, item_index, item) {
      this.edit_list = list_index;
      this.edit_item = item_index;
      this.edit = item;
      var target = list_index + "-" + item_index;
      setTimeout(() => {
        document.getElementById(target).focus();
      }, 50);
    },
    editOff() {
      this.edit_list = -1;
      this.edit_item = -1;
    },
    onFileChange(event, list_index, item_index) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$set(this.data.list[list_index][item_index], 'value', e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },
    confirm(list_index, item_index, edit_index, value, confirm, column) {
      if (confirm) {
        const h = this.$createElement;
        this.$msgbox({
          title: "カラムの編集",
          type: "warning",
          message: h("p", null, [h("span", null, "カラムの編集を実行しますか？"), h("br", null, ""), h("span", null, "この操作は取り消せません")]),
          showCancelButton: true,
          confirmButtonClass: "danger",
          confirmButtonText: "編集",
          cancelButtonText: "キャンセル",
        })
          .then(() => {
            this.editChange(list_index, edit_index, value, column);
          })
          .catch(() => {
            if (this.data.list[list_index][item_index].value == 1) {
              this.data.list[list_index][item_index].value = 0;
            } else {
              this.data.list[list_index][item_index].value = 1;
            }
          });
      } else {
        this.editChange(list_index, edit_index, value, column);
      }
    },
    editChange(list_index, edit_index, value, column) {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("type", this.type);
      params.append("edit_index", edit_index);
      params.append("edit_value", value);
      params.append("id", this.data.list[list_index][0].value);
      params.append("edit_column", column);
      this.axios
        .post(editAPI, params)
        .then((response) => {
          if (response.data.status == "OK") {
            this.load(true);
            this.editOff();
            this.$message({
              message: response.data.message,
              type: "success",
              offset: 7,
              showClose: true,
            });
          } else {
            this.load(true);
            this.editOff();
            this.$message({
              message: response.data.message,
              type: "error",
              offset: 7,
              showClose: true,
            });
          }
        })
        .catch(() => {});
    },
    getInfo(list_index, item_index) {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("account_name", this.data.list[list_index][1].value);
      params.append("email", this.data.list[list_index][item_index].value);
      this.axios
        .post(getInfoAPI, params)
        .then((response) => {
          if (response.data.status == "OK") {
            this.load(true);
          }
        })
        .catch(() => {});
    },
    eLogin(value) {
      let routeData = this.$router.resolve({
        name: "login",
        query: {
          e: true,
          i: value,
        },
      });
      window.open(routeData.href, "_blank");
    },
    scrollTop() {
      var itemArea = document.getElementById("data-table");
      itemArea.scrollTop = 0;
    },
    openDrawer(value) {
      this.drawer = true;
      document.documentElement.style.overflow = "hidden";
      let routeName = "admin_influencerDetailDrawer";
      if (this.type === "tiktoker_list") {
        routeName = "admin_tiktokerDetailDrawer";
      } else if (this.type === "youtuber_list") {
        routeName = "admin_youtuberDetailDrawer";
      }
      const params = {
        child: true,
        parent_component: "admin",
      };
      if (this.type === "youtuber_list") {
        params.channel_id = value;
      } else {
        params.account_name = value;
      }
      this.$router.push({
        name: routeName,
        params,
      });
    },
    closeDrawer() {
      this.drawer = false;
      document.documentElement.style.overflow = "auto";
      this.$refs.iDetail.closeParentDrawer();
      this.$router.push({
        name: "admin",
        params: {
          backpage: true,
        },
      });
    },
    timeNow() {
      var date = new Date();
      var timestamp = date.getTime();
      this.timestamp = Math.floor(timestamp / 1000) - 60 * 5;
    },
    updateData(list_index) {
      this.processing = true;
      let params = new URLSearchParams();
      params.append("type", this.type);
      if (this.type.match(/influencer/)) {
        params.append("id", this.data.list[list_index][1].value);
        params.append("account_name", this.data.list[list_index][2].value);
      } else if (this.type.match(/tiktoker/)) {
        params.append("id", this.data.list[list_index][0].value);
      } else if (this.type.match(/youtuber/)) {
        params.append("id", this.data.list[list_index][0].value);
      } else {
        this.processing = false;
        return;
      }
      this.axios
          .post(updateData, params)
          .then(() => {
            this.processing = false;
            this.$alert("インフルエンサー更新バッチの実行を行いました。5分程度経過した後ご確認ください。")
          })
          .catch((error) => {
            this.$alert("エラーが発生しました。時間をおいて実行してください。" + error)
            this.processing = false;
            console.log(error);
          });
    },
    changeSuperAdmin(list_index) {
      let params = new URLSearchParams();
      params.append("person_id", this.data.list[list_index][0].value);
      params.append("client_id", this.data.list[list_index][1].value);
      params.append("token", this.token);
      this.axios
        .post(loadSuperAdminAPI, params)
        .then((response) => {
          let responseData = response.data.data
          this.old_super_admin_person_id = responseData.old_super_admin_person_id

          this.$confirm("スーパー管理者を変更しますか。<br>（旧スーパー管理者は管理者の権限に変更されます）<br>クライアントID：" + responseData.client_id + "<br>クライアント名：" + responseData.client_name + "<br>変更前スーパー管理者：" + responseData.old_super_admin_person_name + "<br>変更後スーパー管理者：" + this.data.list[list_index][3].value, "スーパー管理者変更", {
            dangerouslyUseHTMLString: true,
            distinguishCancelAndClose: true,
            type: "info",
            confirmButtonText: "変更",
            cancelButtonText: "キャンセル",
          }).then(() => {
            let params = new URLSearchParams();
            params.append("client_id", this.data.list[list_index][1].value);
            params.append("token", this.token);
            params.append("old_super_admin_person_id", this.old_super_admin_person_id);
            params.append("new_super_admin_person_id", this.data.list[list_index][0].value);

            this.axios
            .post(changeSuperAdminAPI, params)
            .then((response) => {
              if(response.data.status === "OK") {
                this.$alert("変更完了しました")
              } else if(response.data.status === "NG") {
                this.$alert("変更に失敗しました", {type: "warning"})
              }
              this.processing = false;

              // 不要データの破棄
              this.old_super_admin_person_id = null

              //画面の更新処理
              this.load();
            })
          })
        })
        .catch(() => {
          this.$alert("変更に失敗しました", {type: "warning"})
          this.processing = false;
        });
    },
    registChange(data) {
      this.admin_regist_modal = true;
      let registColumns = [];
      Object.keys(data.columns).forEach(key => {
        if (data.columns[key].registable == true) {
          registColumns.push({
            label: data.columns[key]['value'],
            label_ja: data.columns[key]['ja'],
            inputType: data.columns[key]['inputType'],
            value: "",
          });
        }
      });
      this.registColumns = registColumns;
      this.tableName = data.table_name;
    },
    deleteChange(list_index) {
      const h = this.$createElement;
      this.$confirm("削除しますか？", {
          title: "削除",
          type: "warning",
          message: h("p", null, [h("span", null, "削除しますか？"), h("br", null, ""), h("span", null, "この操作は取り消せません")]),
          showCancelButton: true,
          confirmButtonClass: "danger",
          confirmButtonText: "削除",
          cancelButtonText: "キャンセル",
      }).then(() => {
        var params = new URLSearchParams();
        params.append("token", this.token);
        params.append("type", this.type);
        params.append("id", this.data.list[list_index][0].value);
        this.axios
          .post(deleteAPI, params)
          .then((response) => {
            if (response.data.status == "OK") {
              this.load(true);
              this.$message({
                message: response.data.message,
                type: "success",
                offset: 7,
                showClose: true,
              });
            } else {
              this.load(true);
              this.$message({
                message: response.data.message,
                type: "error",
                offset: 7,
                showClose: true,
              });
            }
          })
          .catch(() => {
          });
      })
    },
    refreshList() {
      // タブのリフレッシュ処理
      console.log("リフレッシュ実行中");
      this.loading = true;
      this.axios.post(adminGipUpdaterAPI)
          .then((response) => {
            if (handleApiResponse(response)) {
              this.$message.error("リフレッシュに失敗しました。");
            } else {
              this.$message.success("リフレッシュが成功しました。");
            }
          })
          .catch((error) => {
            // 通信エラーなど
            console.error("リフレッシュ中にエラーが発生:", error);
            this.$message.error("リフレッシュ処理中にエラーが発生しました。");
          })
          .finally(() => {
            // 常にローディング停止
            this.loading = false;
            console.log("リフレッシュ終了");
          });
    },
  },
  watch: {
    // サイドメニュー切り替え時のみ呼び出し
    type() {
      this.timeNow();
      this.load();
      setInterval(this.timeNow, 1000);
    }
  },
};
</script>

<style></style>
